<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout

    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <FullScreenLoading v-if="fullScreenloading"/>
  <div class="content-wrapper" v-else>
    <SetupApp v-if="$store.getters.showSetup"/>
    <!-- <MonthToMonthWizard v-else-if="showMonthToMonthWizard"/> -->
    <OutsideOnboarding v-else-if="!onboardingFinished" :userRegistered="true"/>
    <div v-else class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

      <!-- Self Improvee -->

      <TrialExpiredPopup/>
      <!-- <OnboardingTour v-if="!showExpiredMembershipPopup"  :desktop="(windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" /> -->

      <!-- <UserPreferences /> -->
      <SoundEffect />
      <!-- Self Improvee -->

      <!-- <PushNotificationsPopup v-if="$store.getters.onboardingTourFinished"/> -->

      <the-customizer
        v-if                    = "!disableCustomizer"
        :footerType             = "footerType"
        :hideScrollToTop        = "hideScrollToTop"
        :navbarType             = "navbarType"
        :navbarColor            = "navbarColor"
        :routerTransition       = "routerTransition"
        @toggleHideScrollToTop  = "toggleHideScrollToTop"
        @updateFooter           = "updateFooter"
        @updateNavbar           = "updateNavbar"
        @updateNavbarColor      = "updateNavbarColor"
        @updateRouterTransition = "updateRouterTransition" />

      <v-nav-menu
        :navMenuItems = "navMenuItems"
        :title        = "$t('appName')"
        parent        = ".layout--main" />

      <div :style="backgroundImageStyle" id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
        <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType= "navbarType"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]"
          :navMenuItems="navMenuItems" />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]" />
      </template>
      <!-- /Navbar -->

        <div>

          <div class="router-view pt-0">
            <div class="router-content">

              <transition :name="routerTransition">

                <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                  <div
                    class="content-area__heading"
                    :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                    <h2 class="mb-1">{{ routeTitle }}</h2>
                  </div>

                  <!-- BREADCRUMB -->
                  <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                  <!-- DROPDOWN -->
                  <!-- <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                    <vs-button radius icon="icon-settings" icon-pack="feather" />

                    <vs-dropdown-menu class="w-32">
                      <vs-dropdown-item>
                        <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                          <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Profile</span>
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                          <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Tasks</span>
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                          <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Inbox</span>
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>

                  </vs-dropdown> -->

                </div>
              </transition>

              <div class="content-area__content">

                <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                  <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
                </back-to-top>

                <transition :name="routerTransition" mode="out-in">
                  <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
                </transition>
              </div>
            </div>
          </div>
        </div>
        <the-footer :loginAction="() => $router.push('/login')">
          <!-- aaaa -->
           <!-- {{$store.getters.lastAction}} -->


           <AppNotifications/>
           <template v-slot:block2>
             <!-- <ReviewPopup/> -->

           </template>

        </the-footer>
 <!--        <footer if="$store.getters.isMobile && $store.getters.isAnonymous" class="the-footer bg-dark flex justify-center" @click="() => $router.push('/login')">
            <span class="text-dark select-none text-white">
              <span class="font-semibold">Sign up</span> for a free trial here.
             </span>
        </footer> -->

      </div>
    </div>
  </div>
</template>

<!-- Landbot -->
<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheCustomizer       from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
// import OnboardingTour      from '@/views/Self-Improvee/Onboarding/OnboardingTour'
import OutsideOnboarding   from '@/views/Self-Improvee/Onboarding/OutsideOnboarding'
import SetupApp    from '@/views/Self-Improvee/Onboarding/SetupApp'
import SoundEffect         from '@/views/Self-Improvee/Generic/SoundEffect'
import FullScreenLoading   from '@/views/Self-Improvee/Generic/FullScreenLoading'
import UserPreferences     from '@/views/Self-Improvee/Onboarding/UserPreferences'
import TrialExpiredPopup   from '@/views/Self-Improvee/Membership/TrialExpiredPopup'
import ReviewPopup         from '@/views/Self-Improvee/Review/ReviewPopup'
import { setUserId }       from '@/helpers/trackAnalytics'
import * as Sentry         from "@sentry/browser";

// const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    // VxTour,
    // OnboardingTour,
    SoundEffect,
    OutsideOnboarding,
    FullScreenLoading,
    UserPreferences,
    TrialExpiredPopup,
    ReviewPopup,
    SetupApp
  },
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : process.env.VUE_APP_EXPLORATION_MODE ? '#FFB6C1' : (themeConfig.navbarColor || '#fff'),
      navbarType        : themeConfig.navbarType  || 'floating',
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      interval          : null,
      showExpiredMembershipPopup: false,
      // image: { backgroundImage: "url(https://wallpapercave.com/wp/wp6884317.jpg)" },
      // image: { backgroundImage: "url(https://images.unsplash.com/photo-1483750356451-828d7d2cec30?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80)" },
      // image: { backgroundImage: "url(https://images.unsplash.com/photo-1586775490184-b79f0621891f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80)" },
      steps: [
        {
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        }
      ]
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    },
    '$store.getters.todayKey': {
      immediate: false,
      handler (todayKey) {
        console.log('day changed2')
        this.updateUserVisit()
      }
    },
    // '$store.getters.userId': {
    //   immediate: true,
    //   handler (id) {
    //     console.log("clarity: SETUP USER ID", id)
    //     if (id && window.clarity) {
    //       window.clarity("identify", id)
    //     }
    //   }
    // },
  },
  computed: {
    customData () {
      return {
        firestoreId: this.$store.getters.userId,
        tarif: this.$store.getters.userMembership.tarif,
        daysFromRegistration: this.$store.getters.daysFromRegistration,
        trialEndedAgo: this.$store.getters.trialEndedAgo,
        trialEndsOn: this.$store.getters.trialEndsOn,
        activeDays: this.$store.getters.activeDays,
        keyword: this.$store.getters.keyword,
        adgroup: this.$store.getters.adgroup,
        wishTo: this.$store.getters.wishTo,
        name: this.$store.getters.userNameLandbot,
        email: this.$store.getters.userEmail,
        userName: this.$store.getters.userName,
        userAge: this.$store.getters.userAge,
        userStatus: this.$store.getters.userStatus,
        userPositive: this.$store.getters.userPositive,
        userNegative: this.$store.getters.userNegative,
      }
    },
    fullscreenOverlay () {
      return this.$store.getters.showSetup || !this.onboardingFinished
    },
    backgroundImageStyle () {
      if (this.fullscreenOverlay) {
        return { backgroundImage: null }
      }

      if (this.$store.getters.backgroundImageName) {
        return { minHeight: '100vh', backgroundImage: `url(${require('@/assets/images/wallpapers/' + this.$store.getters.backgroundImageName)})`,
        backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed', backgroundSize: 'cover' }
      } else {
        return { backgroundImage: null }
      }
    },
    lastActionToReverse () {
      if (!this.$store.getters.lastAction) return

      if (this.$store.getters.lastAction.action) {
        return this.$store.getters.lastAction.reverse_detail
      }
    },
    fullScreenloading () {
      // return false
      return this.$store.getters.onboardingFinished === undefined
    },
    onboardingFinished () {
      // return false
      return this.$store.getters.onboardingFinished
    },
    // hasMembershipExpired () {
    //   return this.
    // },
    showMonthToMonthWizard () {
      return this.$store.getters.showMonthToMonthWizard
    },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    navMenuItems ()         { return navMenuItems(this) },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    updateUserVisit () {
      console.log("update user visit!!!")
      this.$store.dispatch('UPDATE_USER_VISIT', { notify: this.$vs.notify })
    },
    handleScroll (_) {
      this.$root.$emit('closeAllContextMenus')
    },
    handleUndo () {
      const lastAction = this.$store.getters.lastAction
      if (!lastAction) return

      this.$store.dispatch('UNDO')
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    },
    track () {
      console.log('track')
      if (this.$store.getters) {
        Sentry.setUser({ email: this.$store.getters.userEmail, id: this.$store.getters.userId });
      }

      if (window.smartlook && this.$store.getters) {
        window.smartlook('identify',
          this.$store.getters.userId,
          {
            tarif: this.$store.getters.userMembership.tarif,
            daysFromRegistration: this.$store.getters.daysFromRegistration,
            trialEndedAgo: this.$store.getters.trialEndedAgo,
            activeDays: this.$store.getters.activeDays,
            keyword: this.$store.getters.keyword,
            adgroup: this.$store.getters.adgroup,
            creative: this.$store.getters.creative,
            campaign: this.$store.getters.campaign,
            channel: this.$store.getters.channel,
            wishTo: this.$store.getters.wishTo,
            trialLength: this.$store.getters.trialLength,
          })
      }

      if (this.$store.getters && this.$store.getters.userId) {
        setUserId(this, this.$store.getters.userId)
      }
    },
    initLandbot () {
      if (typeof initLandbot === 'function' ) {
        initLandbot(this.customData)

        setTimeout(
          () => {
            this.sendCustomDataToLandbot()

            if (typeof landbotNewMessageSignalizationStart === 'function') {
              if (this.$store.getters.landbotMessage) {
                window.smartlook('track', 'landbotNewMessageSignalizationStart', { userId: this.$store.getters.userId })
                landbotNewMessageSignalizationStart()
              }
            }

            if (typeof landbotNewMessageSignalizationStop === 'function') {
              window.myLandbot.core.events.on('widget_open', () => {
                console.log('widget_open')
                this.$store.dispatch('UPDATE_LANDBOT_MESSAGE_READ')
                this.$store.dispatch('ADDITIONAL_USER_INFO', { coachOpened: true })
                landbotNewMessageSignalizationStop()
              })

              window.myLandbot.core.events.on('widget_close', () => {
                console.log('widget_close')
                this.$store.dispatch('UPDATE_LANDBOT_MESSAGE_READ')
                landbotNewMessageSignalizationStop()
              })
            }
          }, 1000)
      }
    },
    sendCustomDataToLandbot () {
      if (window.myLandbot) {
        // console.log("sending cusotm data to chatbot", this.customData)
        window.myLandbot.setCustomData(this.customData)
      }
    },
    smartlookIntegration () {
      if (window.initSmartlook) {
        window.initSmartlook(this.$store.getters.country, this.$store.getters.inviter)
      }

      if (window.smartlook) {
        window.smartlook('identify',
          this.$store.getters.userId,
          this.customData)

        if (this.$store.getters.invoiceOverdue) {
          window.smartlook('track', 'invoiceOverdue', { userId: this.$store.getters.userId })
        }
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('FETCH_ALL', { loading: true, notify: this.$vs.notify })
    console.log('main mounted')

    // await this.$store.dispatch('bindGoals')
    this.$store.dispatch('bindTasks')
    this.$store.dispatch('bindReviews')
    this.$store.dispatch('bindLessons')
    this.$store.dispatch('bindNotifications')
    this.$store.dispatch('bindSettings')
    // this.$store.dispatch('bindStories')
    // await this.$store.dispatch('bindRoutinesRef')

    this.track()
    setTimeout(() => { this.track() }, 30000)
    // setTimeout(() => { this.initLandbot() }, 5000)
    setTimeout(() => { this.smartlookIntegration() }, 5000)
    setInterval(() => { this.sendCustomDataToLandbot() }, 15000)
  },
  async created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })


    this.interval = setInterval(() => this.$store.commit('UPDATE_TODAY'), 10000)


    window.addEventListener('scroll', this.handleScroll)

    // this.interval = setInterval(() => this.$store.commit('ADD_DAY'), 60000)
  },

  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })


    window.removeEventListener('scroll', this.handleScroll)

    clearInterval(this.interval)
  }
}
</script>
